import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { ROUTE_PATHS } from 'common/routePaths'

import NotFound from 'errorPages/NotFound'

import Dashboard from './dashboard'
import ProspectAnalysis from './prospectAnalysis'
import ProspectSignup from './prospectSignup'
import { ICHRA_DECISION_TOOL_SIGNUP_PATH } from './prospectSignup/Routes'
import SignupComplete, { SIGNUP_COMPLETE_PATH } from './prospectSignup/SignupComplete'
import ProspectWelcome from './prospectSignup/Welcome'

const { PROSPECT_WELCOME_PATH, PROSPECT_ANALYSIS_PATH } = ROUTE_PATHS

export enum NaviationMapping {
  Prospects = 1,
  ChangePassword = 2,
  Proposal = 3,
}

const Routes = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route key={'Prospect analysis'} path={`${match.path}/${PROSPECT_ANALYSIS_PATH}`} component={ProspectAnalysis} />

      <Route key={'Welcome'} path={`${match.path}/${PROSPECT_WELCOME_PATH}`} component={ProspectWelcome} />
      <Route
        key={'Signup Complete'}
        path={`${match.path}/${SIGNUP_COMPLETE_PATH}/:companyName`}
        component={SignupComplete}
      />

      <Route
        key="Prospect Signup"
        path={`${match.path}/${ICHRA_DECISION_TOOL_SIGNUP_PATH}`}
        component={ProspectSignup}
      />

      <Route key="Dashboard" path={match.path} component={Dashboard} />

      <Route>
        <NotFound />
      </Route>
    </Switch>
  )
}

export default Routes
